import { render } from "./GenericText.vue?vue&type=template&id=92897c80"
import script from "./GenericText.vue?vue&type=script&lang=js"
export * from "./GenericText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/clients/inmaat/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__